export default "__VITE_ASSET__CLK$$LyU__"